import { Alert, AlertCircleIcon, Box, Heading } from '@razorpay/blade/components';
import { ComponentContainerWithBorder } from 'components/PayDetails/components/generics/ComponentContainer';
import ComponentSection from 'components/PayDetails/components/generics/ComponentSection';
import ComponentSectionItem from 'components/PayDetails/components/generics/ComponentSectionItem';
import ComponentTable from 'components/PayDetails/components/generics/CtcBreakdownTable';
import { CtcBreakdownData } from 'components/PayDetails/types';
import React from 'react';

const ArrearsPreview = ({ ctcData }: { ctcData: CtcBreakdownData }) => {
  return (
    <Box display="flex" flexDirection="column" gap="spacing.6">
      <Heading size="medium" weight="semibold">
        Arrears
      </Heading>
      {ctcData.arrears?.arrearSources?.includes('sr_and_rlop') ? (
        <Alert
          icon={AlertCircleIcon}
          color="information"
          description={'The arrear is the combination of RLOP arrears and salary revision arrears.'}
          isDismissible={false}
          isFullWidth
        />
      ) : null}
      <ComponentContainerWithBorder>
        <ComponentSection>
          <ComponentSectionItem>
            <ComponentTable
              data={ctcData.arrears!}
              showMonthlyColumn={false}
              amountColumnTitle="Arrear amount"
            />
          </ComponentSectionItem>
        </ComponentSection>
      </ComponentContainerWithBorder>
    </Box>
  );
};

export default ArrearsPreview;
